import { Component, OnInit } from '@angular/core'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { navItems } from './menu-items'
import { filter, map, mergeMap, tap } from 'rxjs/operators'
import { AuthService } from '@resultsgate-ui/shared'
import { BsLocaleService } from 'ngx-bootstrap/datepicker'

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: `
        <ng-container *ngIf="initDone">
            <ng-container *ngIf="shell; else noShell">
                <ui-layout [sideBarMenuItems]="menuItems"></ui-layout>
            </ng-container>

            <ng-template #noShell>
                <router-outlet *ngIf="initDone" data-test="one"></router-outlet>
            </ng-template>
        </ng-container>
    `,
})
export class AppComponent implements OnInit {
    menuItems = navItems
    shell = false
    initDone = false

    constructor(
        private router: Router,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private auth: AuthService,
        private localeService: BsLocaleService
    ) {
        let userBrowserLang = this.translate.getBrowserLang()
        console.log(`Browser lang ${userBrowserLang}`)
        userBrowserLang = userBrowserLang.match(/cs|cz/) ? 'sk' : userBrowserLang
        translate.addLangs(['en', 'sk'])

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(userBrowserLang.match(/en|sk/) ? userBrowserLang : 'en')

        const lang = document.createAttribute('lang')
        lang.value = translate.currentLang
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('en')
    }

    ngOnInit() {
        this.auth.currentUser$.pipe(filter((v) => v !== null)).subscribe((user) => {
            console.log(`User change obs, switch lang to ${user.locale.toLowerCase()}`)
            if (user) {
                let newLocale = user.locale.toLowerCase()
                this.localeService.use(newLocale)
                if (newLocale === 'cz') {
                    newLocale = 'sk'
                }
                this.translate.use(newLocale)
            }
        })

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                tap((event) => {
                    window.scrollTo(0, 0)
                }),
                map(() => this.route),
                map((route) => {
                    while (route.firstChild) route = route.firstChild
                    return route
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => route.data)
            )
            .subscribe((event) => {
                console.log(`route change ${this.route.snapshot}`)
                this.shell = !(event.shell === false)
                this.initDone = true
            })
    }
}
